export default [
  {
    displayName: "Student Housing Development",
    baseCountry: "Kenya",
    sector: "Consumer Goods",
    summary:
      "Enterprise Software company offering products in Risk & Compliance, Digital Experience, and Operational Excellence, and with an established presence in North Africa and West Africa. Enterprise Software company offering products in Risk & Compliance.",
    isEquityInvestment: true,
    isDebtInvestment: true,
    dealRanges: "00001_00005",
    materials: ["Market studies", "Investment deck", "Financial statements"],
  },
  {
    displayName:
      "Infrastructure investment fund focused on the energy, ICT, transportation, water and social infrastructure sectors ",
    baseCountry: "Nigeria",
    sector: "Design & Constructions",
    summary:
      "Enterprise Software company offering products in Risk & Compliance, Digital Experience, and Operational Excellence, and with an established presence in North Africa and West Africa. The company is capitalizing on the increasing digitization of businesses and government agencies across emerging markets, with a growth plan to also serve low-tech and smaller enterprises in Europe with software solutions better suited to their needs.",
    isEquityInvestment: true,
    isDebtInvestment: false,
    dealRanges: "00001_00005",
    materials: ["Market studies", "Investment deck"],
  },
];
